import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Button, DialogHeader } from '@checkmarx/cx-ui';
import ConfirmationDialog from '../../portal/dialogs/confirmationDialog';

@inject('translationsStore', 'addEditUserStore','usersStore') @observer
export default class ExcemptUserFromMFADialog extends Component {

    state = {
        openMFAExemption: true,
    };

    handleExemptionDialog = e => {
       this.props.addEditUserStore.setTwoFAExemption(this.props.enableExemption);

        this.props.addEditUserStore.updateTwoFAExemptionStatus(this.props.userId, this.props.enableExemption)
            .then(() => {
                this.props.usersStore.getAllUsers();
                this.props.addEditUserStore.reset();
                this.onClose();
        });
    }

    onClose = e => {
        this.setState({
            openMFAExemption: false,
        });
        this.props.onClose();
    }

    render() {
        const confirmDialogContentFormated = <div>{this.props.dialogText}</div>;

        return (
            <div>
                <ConfirmationDialog
                    open={this.props.show}
                    onButtonClick={this.handleExemptionDialog}
                    onCancelClick={this.onClose}
                    buttonText={this.props.buttonText}
                    titleText={this.props.titleText}
                    contentText={this.props.dialogText}
                ></ConfirmationDialog>
            </div>);
    }
}
